const GreeceSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111495)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 14.7829H39.311C38.8095 12.9224 38.0473 11.1692 37.0645 9.56543H20V14.7829Z"
        fill="#338AF3"
      />
      <path
        d="M7.5508 35.652H32.4503C34.2755 34.1982 35.8408 32.4325 37.065 30.4346H2.93604C4.16033 32.4324 5.72564 34.1982 7.5508 35.652Z"
        fill="#338AF3"
      />
      <path
        d="M6.95705 4.83887C5.38471 6.19285 4.02541 7.7873 2.93604 9.56512H6.95705V4.83887Z"
        fill="#338AF3"
      />
      <path
        d="M20 20.0006C20 17.9634 20 16.2585 20 14.7832H12.1739V20.0006H6.95648V14.7832H0.688984C0.240625 16.4468 0 18.1954 0 20.0006C0 21.8059 0.240625 23.5545 0.688984 25.218H39.3111C39.7594 23.5545 40 21.8059 40 20.0006H20Z"
        fill="#338AF3"
      />
      <path
        d="M20.0004 0C17.2231 0 14.5782 0.566641 12.1743 1.58969V9.56523H20.0004C20.0004 7.74398 20.0004 6.195 20.0004 4.34781H32.4502C29.0337 1.62688 24.7074 0 20.0004 0Z"
        fill="#338AF3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111495">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GreeceSvg;
